// extracted by mini-css-extract-plugin
module.exports = {"conteiner":"FAQ_conteiner__3Zkix"};